<template>
  <div class="text-[0.875rem] leading-[1.5rem] text-[#7A7A85] italic">
    <h2>Password should include:</h2>

    <div class="flex">
      <span v-if="hasEightCharacters" class="mr-[8px]"> ✅ </span>
      <span v-else class="mr-[8px]"> • </span>
      <span style="width: calc(100% - 28px)"> At least 8 characters </span>
    </div>
    <div class="flex">
      <span v-if="hasOneUpperCase" class="mr-[8px]"> ✅ </span>
      <span v-else class="mr-[8px]"> • </span>
      <span style="width: calc(100% - 28px)"> At least 1 upper case character </span>
    </div>
    <div class="flex">
      <span v-if="hasOneLowerCase" class="mr-[8px]"> ✅ </span>
      <span v-else class="mr-[8px]"> • </span>
      <span style="width: calc(100% - 28px)"> At least 1 lower case character </span>
    </div>
    <div class="flex">
      <span v-if="hasOneNumber" class="mr-[8px]"> ✅ </span>
      <span v-else class="mr-[8px]"> • </span>
      <span style="width: calc(100% - 28px)"> At least 1 number (0-9) </span>
    </div>
    <div class="flex">
      <span v-if="hasOneSymbol" class="mr-[8px]"> ✅ </span>
      <span v-else class="mr-[8px]"> • </span>
      <span style="width: calc(100% - 28px)"> At least 1 special character </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasEightCharacters: {
      type: Boolean,
      required: true,
    },
    hasOneUpperCase: {
      type: Boolean,
      required: true,
    },
    hasOneLowerCase: {
      type: Boolean,
      required: true,
    },
    hasOneNumber: {
      type: Boolean,
      required: true,
    },
    hasOneSymbol: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
